export enum RouterPathEnum {
  LOGIN = "login",
  DGO = "dgo",
  HOME = "meeting",
  DASHBOARD = "dashboard",
  ADMIN = "admin",
  MEETINGS = "meetings",
  INTERVENTION_LABEL = "interventionlabel",
  ACRONYMS = "acronyms",
  USER_MANAGEMENT = "usermanagement",
  UNAUTHORIZED = "unauthorized",
  ACCESS_DENIED = "accessdenied",
  PAGE_NOT_FOUND = "pagenotfound",
  USER_REQUEST = "user-request",
  USER_INACTIVE = "user-inactive",
}
